import { render } from "./Formmask.vue?vue&type=template&id=20bb92dc"
import script from "./Formmask.vue?vue&type=script&lang=js"
export * from "./Formmask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__